/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MeModule { 
    code?: string | null;
    label: string;
    icon?: string | null;
    /**
     * Ruta de Flutter
     */
    mobileRoute?: string | null;
    /**
     * Ruta de la web o URL externa
     */
    routerLink?: string | null;
    navSlot?: MeModule.NavSlotEnum | null;
    navOrder?: number | null;
    /**
     * code del módulo padre
     */
    parentCode?: string | null;
    isNew?: boolean;
    /**
     * routerLink es una URL externa (hipervínculo)
     */
    external?: boolean;
    /**
     * Sección del menú web a la que pertenece (label del padre)
     */
    parentLabel?: string | null;
    /**
     * Orden en el menú web
     */
    order?: number | null;
}
export namespace MeModule {
    export type NavSlotEnum = 'bottom' | 'menu' | 'fab' | 'hidden' | 'null';
    export const NavSlotEnum = {
        Bottom: 'bottom' as NavSlotEnum,
        Menu: 'menu' as NavSlotEnum,
        Fab: 'fab' as NavSlotEnum,
        Hidden: 'hidden' as NavSlotEnum,
        Null: 'null' as NavSlotEnum
    };
}


